export default __webpack_public_path__ + "static/media/Pipedrive.c80d913c.svg";